import { getOptionalEnvVar, isDevelopment } from '@/lib/env';

interface Config {
  API_BASE_URL: string;
  WS_BASE_URL: string;
  APP_NAME: string;
  ENVIRONMENT: 'development' | 'staging' | 'production';
  CLERK_PUBLISHABLE_KEY?: string;
}

const config: Config = {
  API_BASE_URL: getOptionalEnvVar('VITE_API_BASE_URL', 'http://localhost:8000')!,
  WS_BASE_URL: getOptionalEnvVar('VITE_WS_BASE_URL', 'ws://localhost:8000')!,
  APP_NAME: getOptionalEnvVar('VITE_APP_NAME', 'wrnt_agent')!,
  ENVIRONMENT: (getOptionalEnvVar('VITE_ENVIRONMENT') as Config['ENVIRONMENT']) || (isDevelopment() ? 'development' : 'production'),
  CLERK_PUBLISHABLE_KEY: getOptionalEnvVar('VITE_CLERK_PUBLISHABLE_KEY'),
};

export default config;
